// InstitutionRegistration.js
import React from 'react';

const features = [
  {
    icon: 'bi bi-building',
    title: '500+ Institutions',
    desc: 'Schools & colleges registered',
    bg: '#e9f5ff',
  },
  {
    icon: 'bi bi-award',
    title: 'Accreditation',
    desc: 'Government recognized',
    bg: '#f3e8ff',
  },
  {
    icon: 'bi bi-tools',
    title: 'Management Tools',
    desc: 'Complete admin suite',
    bg: '#e9fff0',
  },
  {
    icon: 'bi bi-graph-up',
    title: 'Analytics',
    desc: 'Performance insights',
    bg: '#fff5e6',
  },
];

const InstitutionRegistration = () => {
  return (
    <>
      <div className=" py-5 d-flex align-items-center yinstitution">
        <div className='container'>
        <div className="row align-items-center w-100">
          {/* Left Column */}
          <div className="col-lg-6 mb-4 mb-lg-0">
            <h1 className="fw-bold display-4">
              Register Your{' '}
              <span className="y-register-your">Institution</span>
            </h1>
            <p className="lead mt-3 mb-4 text-secondary">
              Join our comprehensive education management platform. Register your school or college to access advanced training tools,
              certification programs, and student management systems.
            </p>
            {/* <div className="d-flex flex-wrap gap-3">
              <button className="btn btn-primary btn-lg px-4 shadow-sm">
                Register Institution <i className="bi bi-arrow-right-short ms-1"></i>
              </button>
              <button className="btn btn-outline-secondary btn-lg px-4 shadow-sm">
                <i className="bi bi-play-circle me-1"></i> Watch Demo
              </button>
            </div> */}
          </div>

          {/* Right Column */}
          <div className="col-lg-6 align-items-center justify-content-center">
            <div className="row g-3 justify-content-center align-items-center">
              {features.map((feature, index) => (
                <div className="col-lg-6" key={index}>
                  <div className="p-4 rounded shadow-sm bg-white h-100">
                    <div className="mb-3 icon-wrapper">
                      <i className={`${feature.icon} fs-4 text-primary`}></i>
                    </div>
                    <h5 className="fw-semibold fs-6">{feature.title}</h5>
                    <p className="text-muted mb-0 small">{feature.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        </div>
      </div>
    </>
  );
};

export default InstitutionRegistration;